import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/instuction_dashes.jpg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-0a8bf9ff"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Вы можете скачать каждую таблицу или график дашборда по отдельности. Для этого в правом верхнем углу таблицы кликните на иконку \"...\", затем выберите \"Сохранить как\" -> XLSX. Пример представлен на рисунке ниже. ", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img-container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "instruction",
    width: "600px"
  })
], -1))
const _hoisted_3 = { class: "flex buttons" }

import { ref, watch } from "vue";
import Dialog from "primevue/dialog";
import Button from "primevue/button";


export default /*#__PURE__*/_defineComponent({
  __name: 'DownloadDashboardDialog',
  props: {
    visible: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const visibleLocal = ref(props.visible);
watch(
  () => props.visible,
  (newValue) => {
    visibleLocal.value = newValue;
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: visibleLocal.value,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((visibleLocal).value = $event)),
    onHide: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close'))),
    modal: "",
    header: "Инструкция по скачиванию",
    style: { width: '50vw' }
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(Button), {
          type: "button",
          label: "Закрыть",
          severity: "secondary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        })
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})